import { render, staticRenderFns } from "./EnvironmentForm.vue?vue&type=template&id=4e1a983b"
import script from "./EnvironmentForm.vue?vue&type=script&lang=js"
export * from "./EnvironmentForm.vue?vue&type=script&lang=js"
import style0 from "./EnvironmentForm.vue?vue&type=style&index=0&id=4e1a983b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports